import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('PopoverContentHeader', slot);
}

export const popoverContentHeaderClasses = generateUtilityClasses('PopoverContentHeader', [
  'root',
  'title',
  'icon',
]);

export type PopoverContentHeaderClasses = typeof popoverContentHeaderClasses;
